import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ title }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false); // Close the menu after clicking a link
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link onClick={() => handleScroll('registration')} to="/" className="navbar-title-link">
          <h1>{title || 'Digital Twins for AEC & Facility Managers'}</h1>
        </Link>
      </div>
      <div className={`navbar-right ${menuOpen ? 'open' : ''}`}>
        <ul>
          <li><Link to="/" onClick={() => handleScroll('registration')}>Home </Link></li>
          <li><Link to="/location">Location </Link></li>
          <li><Link to="/agenda">Agenda </Link></li>
          <li><Link to="/speakers">Speakers </Link></li>
          {/* <li><Link to="/info">Info </Link></li> */}
          <li><Link to="/organizers">Organizers </Link></li>
        </ul>
      </div>
      <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        &#9776;
      </button>
    </nav>
  );
};

export default Navbar;
